import {
  Box,
  Button,
  TextField,
  Typography,
} from "@mui/material";

import PhoneNumberField from "../../common/PhoneNumberField";

const ProductionReportCommonFilter = ({
  filters,
  handleFilterChange,
  handlePhoneBlur,
  handlePhoneChange,
  fieldErrors,
  isMobile,
  searchError,
  resetCounter,
  handleSubmit,
  handleReset,
}) => {
  return (
    <>
      <Box mb={3} p={2} sx={{ border: "1px solid #e0e0e0", borderRadius: "8px" }}>
        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "16px",
            marginBottom: "16px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              alignItems: "center",
            }}
          >
            {/* Customer Name */}
            <Box sx={{ flex: isMobile ? "1 1 100%" : "1 1 200px" }}>
              <label
                htmlFor="customer-name"
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  display: "block",
                  marginBottom: 4,
                }}
              >
                Customer Name
              </label>
              <TextField
                name="customerName"
                id="customer-name"
                size={isMobile ? "small" : "medium"}
                value={filters.customerName}
                onChange={(e) => {
                  const regex = /^[A-Za-z\s]*$/;
                  if (regex.test(e.target.value) && e.target.value.length <= 50) {
                    handleFilterChange(e); 
                  }
                }}
                inputProps={{ maxLength: 50 }}
                fullWidth
              />
            </Box>

            {/* Policy Number */}
            <Box sx={{ flex: isMobile ? "1 1 100%" : "1 1 200px" }}>
              <label
                htmlFor="policy-number"
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  display: "block",
                  marginBottom: 4,
                }}
              >
                Policy Number
              </label>
              <TextField
                name="policyNumber"
                id = "policy-number"
                size={isMobile ? "small" : "medium"}
                value={filters.policyNumber}
                onChange={(e) => {
                  if (e.target.value.length <= 30) {
                    handleFilterChange(e);
                  }
                }}
                fullWidth
                inputProps={{
                  maxLength: 30,
                }}
              />
            </Box>

            {/* Email */}
            <Box sx={{ flex: isMobile ? "1 1 100%" : "1 1 200px" }}>
              <label
                htmlFor="email-id"
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  display: "block",
                  marginBottom: 4,
                }}
              >
                Email
              </label>
              <TextField
                name="emailId"
                id="email-id"
                size={isMobile ? "small" : "medium"}
                value={filters.emailId}
                onChange={(e) => {
                  if (e.target.value.length <= 75) {
                    handleFilterChange(e);
                  }
                }}
                fullWidth
                error={Boolean(fieldErrors.emailId)}
                helperText={fieldErrors.emailId}
                FormHelperTextProps={{
                  style: { minHeight: "20px", margin: 0 },
                }}
                inputProps={{
                  maxLength: 75,
                }}
              />
            </Box>

           <Box sx={{ flex: isMobile ? "1 1 100%" : "1 1 200px",  mt: "3px", "& .MuiInputBase-root": {  height: "57px !important",},}}>
              <PhoneNumberField
                name="phoneNumber"
                size={isMobile ? "small" : "medium"}
                value={filters.phoneNumber}
                onChange={handlePhoneChange}
                onBlur={handlePhoneBlur}
                fullWidth
                error={Boolean(fieldErrors.phoneNumber)}
                helperText={fieldErrors.phoneNumber}
                FormHelperTextProps={{
                  style: { minHeight: "0px", margin: 0 },
                }}
                resetTrigger={resetCounter}
                labelStyle={{ fontSize: 14, fontWeight: 500 ,mb:0.3}}
                required={false}
              />
            </Box>

            {/* Premium */}
            <Box sx={{ flex: isMobile ? "1 1 100%" : "1 1 200px" }}>
              <label
                htmlFor="premium"
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  display: "block",
                  marginBottom: 4,
                }}
              >
                Premium
              </label>
              <TextField
                name="premium"
                id="premium"
                size={isMobile ? "small" : "medium"}
                type="number"
                value={filters.premium}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val.length <= 10) {
                    handleFilterChange(e);
                  }
                }}
                fullWidth
                inputProps={{
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                }}
              />
            </Box>

            {/* Buttons */}
            <Box
              sx={{
                display: "flex",
                gap: 2,
                flex: isMobile ? "1 1 100%" : "0 0 auto",
                justifyContent: isMobile ? "space-between" : "flex-end",
                width: isMobile ? "100%" : "auto",
                mt: 3,
              }}
            >
              <Button
                onClick={handleSubmit}
                variant="contained"
                className="btn-sm-secondary"
                size={isMobile ? "small" : "medium"}
                sx={{
                  textTransform: 'none',
                  fontSize: '15px',
                  minWidth: isMobile ? "48%" : "120px",
                  height: isMobile ? "40px" : "55px",
                  '&:focus': {
                    outline: '1px solid #E69C00',
                  },
                }}
              >
                Search
              </Button>
              <Button
                onClick={handleReset}
                variant="outlined"
                className="btn-sm-secondary"
                size={isMobile ? "small" : "medium"}
                sx={{
                  textTransform: 'none',
                  fontSize: '15px',
                  minWidth: isMobile ? "48%" : "120px",
                  height: isMobile ? "40px" : "55px",
                  '&:focus': {
                    outline: '1px solid #E69C00',
                  },
                }}
              >
                Reset
              </Button>
            </Box>
          </Box>

          {/* Search Error */}
          {searchError && (
            <Typography
              variant="caption"
              color="error"
              sx={{ display: "block", mt: 0.5 }}
            >
              {searchError}
            </Typography>
          )}
        </Box>
      </Box>
    </>
  );
};

export default ProductionReportCommonFilter;
